"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeType = void 0;
var DateRangeType;
(function (DateRangeType) {
    DateRangeType[DateRangeType["startsInRange"] = 1] = "startsInRange";
    DateRangeType[DateRangeType["overlapsWithRange"] = 2] = "overlapsWithRange";
})(DateRangeType = exports.DateRangeType || (exports.DateRangeType = {}));
//# sourceMappingURL=DeliveryBlocks.consts.js.map